import {
  SERVING_PRICE_CLASS,
  SUBSCRIPTION_INPUT_NAME,
  TOTAL_PRICE_CLASS
} from '../../../classnames/above-the-fold';
import { RADIO_LABEL_CLASS } from '../../../classnames/design-system';
import {
  OTP_DISCOUNTED_PRICE_VALUE,
  OTP_PRICE_VALUE,
  SERVING_PRICE_VALUE,
  SUBSCRIPTION_PRICE_VALUE
} from '../../../classnames/product-card';
import { formatCents } from '../../../utils/money';
import Selectors from '../selectors';

// TODO - rethink/rewrite price handlers - we need to have a better structure
// for product/above-the-fold/product-card price handlers. Use proper inheritance
export default class BasePriceHandler {
  selectors = (node) => new Selectors(node);
  pricePrecision = 2;

  updatePrice = (
    price,
    subscriptionUnitPrice,
    servings,
    subscriptionState,
    quantity,
    node,
    otpDiscount,
    disablePricePrecision,
    productId
  ) => {
    if (node.dataset.productId !== String(productId)) {
      return;
    }

    if (disablePricePrecision) {
      this.pricePrecision = 0;
    }

    const oneTimeUnitPrice = parseFloat(price);
    const currentUnitPrice = subscriptionState === 'subscription' ? subscriptionUnitPrice : oneTimeUnitPrice;

    const currentPrice = currentUnitPrice * quantity;
    const subscriptionPrice = subscriptionUnitPrice * quantity;
    const oneTimePrice = oneTimeUnitPrice * quantity;
    const perServingPrice = currentUnitPrice / parseFloat(servings);

    this.updateCurrentPrice(currentPrice, otpDiscount, node);
    // TODO - move serving handlings to one place!
    // we have js-above-the-fold-serving-price and js-serving-quantity
    this.updatePerServingPrice(perServingPrice, otpDiscount, node);
    this.updateSubscriptionPrice(subscriptionPrice, oneTimePrice, node);
    this.updateOneTimePrice(oneTimePrice, otpDiscount, node);
  };

  updateCurrentPrice = (price, otpDiscount, node) => {
    let totalPrice = price;

    const priceElements = node.getElementsByClassName(TOTAL_PRICE_CLASS);

    if (otpDiscount) {
      totalPrice = price - (price * (otpDiscount / 100));
    }

    [...priceElements].forEach((element) => {
      element.innerHTML = formatCents(totalPrice, this.pricePrecision);
    });
  };

  updatePerServingPrice = (price, otpDiscount, node) => {
    let servingPrice = price;

    const priceElements = node.getElementsByClassName(SERVING_PRICE_CLASS);

    if (otpDiscount) {
      servingPrice = price - (price * (otpDiscount / 100));
    }

    [...priceElements].forEach((element) => {
      element.innerHTML = `${formatCents(servingPrice)}/serving`;
    });
  };

  updateSubscriptionPrice = (subscriptionPrice, oneTimePrice, node) => {
    let finalizedSubscriptionPrice = subscriptionPrice;

    const priceElements =
      node.querySelectorAll(`[name="${SUBSCRIPTION_INPUT_NAME}"][value="subscription"] .${RADIO_LABEL_CLASS}`);

    [...priceElements].forEach((element) => {
      const subPriceValueElement = element.querySelector(`.${SUBSCRIPTION_PRICE_VALUE}`);
      const otpPriceValueElement = element.querySelector(`.${OTP_PRICE_VALUE}`);

      const { discount } = subPriceValueElement.dataset;

      if (discount) {
        finalizedSubscriptionPrice = subscriptionPrice * (1 - discount / 100);
      }

      if (element.dataset.otpPrice === 'true' && subPriceValueElement && otpPriceValueElement) {
        subPriceValueElement.innerHTML = formatCents(finalizedSubscriptionPrice, this.pricePrecision);
        otpPriceValueElement.innerHTML = formatCents(oneTimePrice, this.pricePrecision);
      }
    });
  };

  updateOneTimePrice = (price, otpDiscount, node) => {
    const priceElements =
      node.querySelectorAll(`[name="${SUBSCRIPTION_INPUT_NAME}"][value="one-time"] .${RADIO_LABEL_CLASS}`);

    [...priceElements].forEach((element) => {
      const otpPriceValueElement = element.querySelector(`.${OTP_PRICE_VALUE}`);
      const discountedPriceElement = element.querySelector(`.${OTP_DISCOUNTED_PRICE_VALUE}`);
      const servingPriceElement = element.querySelector(`.${SERVING_PRICE_VALUE}`);

      if (!element.children.length) return;

      const servingPrice = servingPriceElement?.dataset?.servingPrice;

      if (otpDiscount) {
        discountedPriceElement.innerHTML = formatCents(price - (price * (otpDiscount / 100)), this.pricePrecision);
        otpPriceValueElement.classList.add('otp-price-label__line-through');
        otpPriceValueElement.classList.remove('otp-price-label__actual-price');
        otpPriceValueElement.removeAttribute('data-testid');
        discountedPriceElement.classList.add('otp-price-label__actual-price');
        discountedPriceElement.dataset.testid = 'one-time-price-value';
      } else {
        discountedPriceElement.innerHTML = '';
        discountedPriceElement.removeAttribute('data-testid');
        otpPriceValueElement.classList.remove('otp-price-label__line-through');
        otpPriceValueElement.classList.add('otp-price-label__actual-price');
        otpPriceValueElement.dataset.testid = 'one-time-price-value';
      }

      if (servingPrice) {
        servingPriceElement.innerHTML = formatCents((servingPrice - (servingPrice * (otpDiscount / 100))));
      }

      otpPriceValueElement.innerHTML = formatCents(price, this.pricePrecision);
    });
  };
}
